import { copy } from 'shared/lib/copy';
import { propertyType } from 'shared/constants.json';

export default function useCleanFilter(propertySvc, userSvc, spaceSvc) {
  const filterFunc = (props) => (current) => {
    if (Array.isArray(current.children) && current.children.length > 0) {
      current.children = current.children.filter((next) => filterFunc(props)(next));
      return current.children.length > 0;
    }

    if (current.scope === undefined) {
      return false;
    }

    if (current.scope.directProperty !== undefined) {
      const prop = props.find((p) => p.property.edgeName === current.scope.directProperty.edgeName);
      return prop !== undefined;
    }

    if (current.scope.property !== undefined) {
      if (!props.map((p) => p.property.uid).includes(current.scope.property.uid)) {
        return false;
      }

      if (current.scope.property.type === propertyType.lookup) {
        const prop = props.find((p) => p.property.uid === current.scope.property.uid);

        if (prop.property.lookupRelation.uid !== current.scope.property.lookupRelation.uid) {
          return false;
        }
        if (prop.property.lookupProperty.uid !== current.scope.property.lookupProperty.uid) {
          return false;
        }
      }
    }

    return true;
  };

  const cleanUsers = (filter) => {
    const knownUsers = userSvc.users.value.map((u) => u.uid);

    const reduceFn = (res, next) => {
      if (Array.isArray(next.children) && next.children.length > 0) {
        next.children = next.children.reduce(reduceFn, []);
        res.push(next);
        return res;
      }

      if (next.scope?.users === undefined) {
        res.push(next);
        return res;
      }

      res.push({
        ...next,
        scope: {
          ...next.scope,
          users: next.scope.users.filter((u) => knownUsers.includes(u.uid)),
        },
      });
      return res;
    };

    return filter.reduce(reduceFn, []);
  };

  const cleanSelectedSpaces = (filter) => {
    const validSpaces = spaceSvc.allSpaces.value.map((o) => o.uid);

    const reduceFn = (res, next) => {
      if (Array.isArray(next.children) && next.children.length > 0) {
        next.children = next.children.reduce(reduceFn, []);
        res.push(next);
        return res;
      }

      if (next.scope?.spaces === undefined) {
        res.push(next);
        return res;
      }

      res.push({
        ...next,
        scope: {
          ...next.scope,
          spaces: next.scope.spaces.filter((o) => validSpaces.includes(o.uid)),
        },
      });
      return res;
    };

    return filter.reduce(reduceFn, []);
  };

  const cleanSelectedOptions = (filter) => {
    const validOptions = propertySvc.properties.value.reduce((res, next) => {
      if (next.options !== undefined) {
        res.push(...next.options.map((o) => o.uid));
        return res;
      }

      return res;
    }, []);

    const reduceFn = (res, next) => {
      if (Array.isArray(next.children) && next.children.length > 0) {
        next.children = next.children.reduce(reduceFn, []);
        res.push(next);
        return res;
      }

      if (next.scope?.selectedOptions === undefined) {
        res.push(next);
        return res;
      }

      res.push({
        ...next,
        scope: {
          ...next.scope,
          selectedOptions: next.scope.selectedOptions.filter((o) => validOptions.includes(o.uid)),
        },
      });
      return res;
    };

    return filter.reduce(reduceFn, []);
  };

  const cleanFilter = ({ filter, props }) => {
    if (filter === null) {
      return null;
    }

    const res = copy(filter);
    res.children = res.children.filter(filterFunc(props));
    res.children = cleanSelectedSpaces(res.children);
    res.children = cleanSelectedOptions(res.children);
    res.children = cleanUsers(res.children);

    return res;
  };

  return { cleanFilter };
}
